<template>
    <div class="hidden md:block">
        <p class="font-light mb-2 hidden md:block" v-line-clamp:20="lineCount">{{ description }}</p>
        <button type="button" class="no-underline text-perrywinkle-two font-bold text-lg hidden md:block" aria-label="Read more" v-show="this.lineCount" @click="readMore()">Read more</button>
        <button type="button" v-show="!this.lineCount" @click="readMore()" class="h-12 w-full flex justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" class="fill-current text-perrywinkle">
                <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lineCount: 2,
        }
    },
    methods: {
        readMore() {
            this.lineCount = this.lineCount ? 0 : 2;
        }
    },
    props: {
        description: {
            type: String,
            default: ""
        }
    }
}
</script>